<template>
    <teleport to="body">
        <van-action-bar>
            <van-action-bar-icon icon="description" text="预约报名" @click="onClickIcon"/>
            <van-action-bar-button icon="service" type="danger" text="在线咨询" @click="onClickButton"/>
            <van-action-bar-button icon="phone" color="#7232dd" type="danger" text="电话沟通"
                                   @click="onCallPhone"/>
        </van-action-bar>
        <van-popup
                v-model:show="show"
                closeable
                close-icon="close"
                position="bottom"
                :style="{ height: '302px' }"
        >
            <Bm></Bm>

        </van-popup>
    </teleport>
</template>
<script>
import {showToast} from 'vant';
import {ref} from 'vue';
import Bm from "@/components/Bm.vue";
import open53 from "@/api/seviceBtn"
export default {
    name: 'BottomComponent',
    components: {
        Bm
    },
    setup() {
        const show = ref(false)
        const onClickIcon = () => {
            show.value = true
        };
        const onClickButton = () => {
            open53()
        }

        function onCallPhone() {
            window.location.href = 'tel:' + 13971355534;
        }

        return {
            show,
            open,
            onClickIcon,
            onClickButton,
            onCallPhone
        }
    }
}
</script>
<style scoped>

</style>